import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  CornerMarkBatchSet,
  CornerMarkBatchSetVariables
} from "./types/CornerMarkBatchSet";
import {
  CornermarkBulkDelete,
  CornermarkBulkDeleteVariables
} from "./types/CornermarkBulkDelete";
import {
  CornerMarkCancelSet,
  CornerMarkCancelSetVariables
} from "./types/CornerMarkCancelSet";
import {
  CornermarkCreate,
  CornermarkCreateVariables
} from "./types/CornermarkCreate";
import {
  CornermarkDelete,
  CornermarkDeleteVariables
} from "./types/CornermarkDelete";
import {
  CornermarkUpdate,
  CornermarkUpdateVariables
} from "./types/CornermarkUpdate";

const cornermarkBulkDelete = gql`
  mutation CornermarkBulkDelete($ids: [ID!]!) {
    cornerMarkBulkDelete(ids: $ids) {
      errors: cornermarkErrors {
        message
      }
    }
  }
`;

export const useCornermarkBulkDeleteMutation = makeMutation<
  CornermarkBulkDelete,
  CornermarkBulkDeleteVariables
>(cornermarkBulkDelete);

const cornermarkCreate = gql`
  mutation CornermarkCreate($input: CornerMarkInput!) {
    cornerMarkCreate(input: $input) {
      cornerMark {
        id
      }
      errors: cornermarkErrors {
        field
        code
      }
    }
  }
`;

export const useCornermarkCreateMutation = makeMutation<
  CornermarkCreate,
  CornermarkCreateVariables
>(cornermarkCreate);

const cornermarkDelete = gql`
  mutation CornermarkDelete($id: ID!) {
    cornerMarkDelete(id: $id) {
      errors: cornermarkErrors {
        message
      }
    }
  }
`;

export const useCornermarkDeleteMutation = makeMutation<
  CornermarkDelete,
  CornermarkDeleteVariables
>(cornermarkDelete);

const cornermarkUpdate = gql`
  mutation CornermarkUpdate($id: ID!, $input: CornerMarkInput!) {
    cornerMarkUpdate(id: $id, input: $input) {
      errors: cornermarkErrors {
        field
        code
      }
    }
  }
`;

export const useCornermarkUpdateMutation = makeMutation<
  CornermarkUpdate,
  CornermarkUpdateVariables
>(cornermarkUpdate);

const cornerMarkBatchSet = gql`
  mutation CornerMarkBatchSet(
    $id: ID!
    $categoryIds: [ID]
    $collectionIds: [ID]
    $productIds: [ID]
    $variantIds: [ID]
  ) {
    cornerMarkBatchSet(
      id: $id
      categoryIds: $categoryIds
      collectionIds: $collectionIds
      productIds: $productIds
      variantIds: $variantIds
    ) {
      cornerMark {
        id
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useCornerMarkBatchSetMutation = makeMutation<
  CornerMarkBatchSet,
  CornerMarkBatchSetVariables
>(cornerMarkBatchSet);

const cornerMarkCancelSet = gql`
  mutation CornerMarkCancelSet(
    $categoryId: ID
    $collectionId: ID
    $productId: ID
    $variantId: ID
  ) {
    cornerMarkCancelSet(
      categoryId: $categoryId
      collectionId: $collectionId
      productId: $productId
      variantId: $variantId
    ) {
      cornerMark {
        id
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useCornerMarkCancelSetMutation = makeMutation<
  CornerMarkCancelSet,
  CornerMarkCancelSetVariables
>(cornerMarkCancelSet);
